<template>
    <footer class="footer" data-aos="fade-up">
        <div class="container">
            <div class="footer-links">
                <div class="footer-column">
                    <h4>Robotics Services</h4>
                    <ul>
                        <li><a href="#">Artificial Intelligence</a></li>
                        <li><a href="#">Intelligent Robots</a></li>
                        <li><a href="#">Large Language Models</a></li>
                        <li><a href="#">Intelligent Customer Service</a></li>
                        <li><a href="#">Human-Computer Interaction</a></li>
                    </ul>
                </div>
                <div class="footer-column">
                    <h4>Services</h4>
                    <ul>
                        <li><a href="#">Automation Services</a></li>
                        <li><a href="#">Voice Interaction</a></li>
                        <li><a href="#">Intelligent Q&amp;A</a></li>
                    </ul>
                </div>
                <div class="footer-column">
                    <h4>Digital Intelligence</h4>
                    <ul>
                        <li><a href="#">Digital Employees</a></li>
                        <li><a href="#">Smart Services</a></li>
                    </ul>
                </div>
                <div class="footer-column">
                    <h4>Future</h4>
                    <ul>
                        <li><a href="#">Deep Learning</a></li>
                        <li><a href="#">Natural Language Processing</a></li>
                        <li><a href="#">Computer Vision</a></li>
                    </ul>
                </div>
            </div>
            <div class="footer-brand">
                <div class="footer-logo">
                    <img src="../assets/images/logo/logo.png" alt="SXVE-AI" />
                    <span>SXVE-AI</span>
                </div>
                <div class="footer-description">
                    Sxve-ai integrates the latest large-scale models and multimodal AI to achieve precise insights. It
                    serves users and is applicable to every industry and field.
                </div>
            </div>
            <div class="copyright">
                Copyright reserved
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
};
</script>

<style scoped>
.footer {
    /* 直接设置背景图，不添加遮罩 */
    background-image: url('https://www.xael-ai.net/images/7.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-color: #f8f9fa;
    padding: 48px 0 24px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
    border-top: 1px solid #e9ecef;
}

.footer::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(245, 245, 247, 0.92);
    z-index: -1;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.footer-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 40px;
    margin-bottom: 48px;
}

.footer-column {
    flex: 1;
    min-width: 160px;
}

.footer-column h4 {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #212529;
    letter-spacing: 0.5px;
}

.footer-column ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.footer-column li {
    margin-bottom: 0.6rem;
}

.footer-column a {
    color: #6c757d;
    text-decoration: none;
    font-size: 0.9rem;
    transition: color 0.2s;
}

.footer-column a:hover {
    color: #007bff;
    text-decoration: underline;
}

.footer-brand {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 20px;
    padding: 24px 0;
    border-top: 1px solid #e9ecef;
    border-bottom: 1px solid #e9ecef;
    margin-bottom: 24px;
}

.footer-logo {
    display: flex;
    align-items: center;
    gap: 12px;
}

.footer-logo img {
    height: 60px;
    width: auto;
}

.footer-logo span {
    font-weight: 600;
    font-size: 1.2rem;
    color: #212529;
}

.footer-description {
    color: #6c757d;
    font-size: 0.85rem;
    max-width: 500px;
    line-height: 1.5;
}

.copyright {
    text-align: center;
    color: #6c757d;
    font-size: 0.8rem;
    padding-top: 8px;
}

/* 响应式 */
@media (max-width: 768px) {
    .footer-links {
        flex-direction: column;
        gap: 28px;
    }

    .footer-brand {
        flex-direction: column;
        align-items: flex-start;
    }

    .footer-description {
        max-width: 100%;
    }

    .copyright {
        font-size: 0.7rem;
    }
}
</style>